import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { caterButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfHjpfQwDS7o6r8f6Ta1T5_K5HwuhaSOJ66izMKhAf8OAdQfQ/viewform">
              <CFView hover>
                <CFImage
                  src={caterButton}
                  w="100%"
                  maxnWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfHjpfQwDS7o6r8f6Ta1T5_K5HwuhaSOJ66izMKhAf8OAdQfQ/viewform">
              <CFView hover>
                <CFImage src={caterButton} maxWidth="250px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
